var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C10 8 5.73 11.11 4 15.5C5.73 19.89 10 23 15 23C20 23 24.27 19.89 26 15.5C24.27 11.11 20 8 15 8ZM15 20.5C12.24 20.5 10 18.26 10 15.5C10 12.74 12.24 10.5 15 10.5C17.76 10.5 20 12.74 20 15.5C20 18.26 17.76 20.5 15 20.5ZM15 12.5C13.34 12.5 12 13.84 12 15.5C12 17.16 13.34 18.5 15 18.5C16.66 18.5 18 17.16 18 15.5C18 13.84 16.66 12.5 15 12.5Z",
    fill: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.087ef0825ff71c31c56b9be5d22b47c2.svg";
export { ForwardRef as ReactComponent };